import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Login from "./screens/Login";
import Home from "./screens/Home";
import Layout from "./components/Layout";

import Subscriptions from "./screens/Subscriptions";
import CreateSubscription from "./screens/CreateSubscription";
import EditSubscription from "./screens/EditSubscription";
import Categories from "./screens/Category"; // ← import Category screen
import Meals from "./screens/Meals";
import Menus from "./screens/Menus";
import Groups from "./screens/Groups";
import Users from "./screens/Users";
import Customers from "./screens/Customers"; // ← import Customers screen
import Calendar from "./screens/Calendar";
import MenuProcessor from "./screens/MenuProcessor";
import ImageSliders from "./screens/ImageSliders";
import Settings from "./screens/Settings";
import MealAvailability from "./screens/MealAvailability";
import CustomerMeals from "./screens/CustomerMeals";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (garbage collection time)
    },
  },
});

function PrivateRoute({ children }) {
  const isAuth = !!localStorage.getItem("accessToken");
  return isAuth ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Redirect root → home */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* Protected pages */}
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Layout>
                  <Home />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <PrivateRoute>
                <Layout>
                  <Subscriptions />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/subscriptions/create"
            element={
              <PrivateRoute>
                <Layout>
                  <CreateSubscription />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/subscriptions/edit/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <EditSubscription />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/categories" // ← new route
            element={
              <PrivateRoute>
                <Layout>
                  <Categories />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/meals"
            element={
              <PrivateRoute>
                <Layout>
                  <Meals />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/meals-availability"
            element={
              <PrivateRoute>
                <Layout>
                  <MealAvailability />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/menus"
            element={
              <PrivateRoute>
                <Layout>
                  <Menus />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <PrivateRoute>
                <Layout>
                  <Groups />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <PrivateRoute>
                <Layout>
                  <Customers />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Layout>
                  <Settings />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <Layout>
                  <Users />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <PrivateRoute>
                <Layout>
                  <Calendar />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/image-sliders"
            element={
              <PrivateRoute>
                <Layout>
                  <ImageSliders />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/menu-jobs"
            element={
              <PrivateRoute>
                <Layout>
                  <MenuProcessor />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/customer-meals"
            element={
              <PrivateRoute>
                <Layout>
                  <CustomerMeals />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
